import { useBoolean, useBreakpoints } from "@aurem/ui";
import { CompanyBottomNavigation } from "components/mobile/BottomNavigation/CompanyBottomNavigation";
import { Topbar } from "components/Topbar";
import { PageTitleProvider } from "components/Topbar/PageTitle";
import { LayoutInnerSidebar } from "layouts/admin/LayoutInnerSidebar";
import { LayoutOnboardingSidebar } from "layouts/admin/LayoutOnboardingSidebar";
import { LayoutOuterSidebar } from "layouts/admin/LayoutOuterSidebar";
import { BannerProvider, BannerStack } from "providers/BannerProvider";
import { Outlet, useParams } from "react-router-dom";
import { ChatPanel } from "root/ChatPanel";

export const AdminLayout = () => {
  const { companyId } = useParams();
  const { isMobile } = useBreakpoints();

  const {
    value: showOuterSidebar,
    setTrue: openOuterSidebar,
    setFalse: closeOuterSidebar,
  } = useBoolean();

  return (
    <div className="flex flex-col sm:flex-row flex-grow">
      {!isMobile && <LayoutOnboardingSidebar />}
      <LayoutOuterSidebar open={showOuterSidebar} onClose={closeOuterSidebar} />
      {!isMobile && <LayoutInnerSidebar />}
      <PageTitleProvider>
        <BannerProvider>
          <div
            className="flex flex-col grow min-h-0 overflow-y-hidden w-full"
            style={{ maxHeight: "100dvh" }}
          >
            <Topbar openOuterSidebar={openOuterSidebar} />
            <div className="flex flex-col grow min-h-0 overflow-hidden w-full relative">
              <BannerStack />
              <div className="flex flex-col flex-1 min-h-0 overflow-auto">
                <Outlet />
              </div>
              <ChatPanel />
            </div>
            {companyId && isMobile && <CompanyBottomNavigation />}
          </div>
        </BannerProvider>
      </PageTitleProvider>
    </div>
  );
};
